import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Modal, Typography } from '@mui/material';
import React from 'react';

interface NewsItemModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  date: string;
  content: string;
}

const NewsItemModal: React.FC<NewsItemModalProps> = ({
  open,
  onClose,
  title,
  date,
  content,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="news-modal-title"
      aria-describedby="news-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: '600px',
          bgcolor: 'rgba(20, 20, 20, 0.95)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '8px',
          p: 4,
          color: 'white',
          maxHeight: '90vh',
          overflow: 'auto',
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'white',
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="h5"
          sx={{
            fontFamily: 'Bebas Neue',
            fontSize: 'clamp(1.4rem, 2.5vw, 1.8rem)',
            mb: 1,
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 'clamp(0.9rem, 1.5vw, 0.9rem)',
            mb: 3,
          }}
        >
          {date}
        </Typography>
        <Typography
          sx={{
            fontSize: 'clamp(1rem, 1.8vw, 1rem)',
            lineHeight: 1.6,
          }}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Box>
    </Modal>
  );
};

export default NewsItemModal;
